<template>
  <div class="app-container">
    <list ref="list" >
      <template slot="toolbar-right">
        <!-- <el-button size="mini" type="primary" @click="print('qualityPrintbatch')" :disabled='!btntype'>销货单批量打印</el-button> -->
         <!-- <el-button size="mini" type="primary" @click="print('qualityReceipt')" :disabled='!btntype'>小票批量打印</el-button> -->
      </template>
    </list>
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/distribution/printmanagement/billdetail/list";
import importDialog from "@/components/distribution/printmanagement/billdetail/importDialog";
export default {
  name: "receipt",
  mixins: [curdMixins],
  components: {
    list,
    importDialog
  },
  data() {
    return {
      api: require("@/api/fund/receipt").default,
      btntype:false
    }
  },
  methods: {
    // checkChange(e){
    //      if(e.length>0){
    //        this.btntype=true
    //      }else{
    //        this.btntype=false
    //      }
    // },
    // print(url) {
    //   let rows = this.$refs.list.getCheckedRows();
       
    //   sessionStorage.setItem('quality',JSON.stringify(this.checkSameData(rows)))
    //   let newpage = this.$router.resolve({ 
    //     path: '/'+url+'?sid='+ rows.map(v=>v.DocId).join(',')
    //   })
    //   window.open(newpage.href, '_blank');
    // },
    checkSameData(tableData2){
          let cache = {};  //存储的是键是GoodsId 的值，值是GoodsId 在indeces中数组的下标
          let indices = [];  //数组中每一个值是一个数组，数组中的每一个元素是原数组中相同GoodsId的下标
          tableData2.map((item,index)=>{
            let GoodsId = item.GoodsId;
            let _index = cache[GoodsId];
            if(_index!==undefined){
                 indices[_index].push(index)
            }else{
                cache[GoodsId] = indices.length
                indices.push([index])
            }
          })
          let result = [];
          indices.map((item)=>{
            item.map((index)=>{
                result.push(tableData2[index])
            })
          })
          return result
    },
    onImport() {
      this.$refs.importDialog.open();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
  },
};
</script>